import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ChartContainer, ChartTooltip, ChartTooltipContent } from '@/components/ui/chart';
import { Line, LineChart, CartesianGrid, XAxis, YAxis } from 'recharts';
import { motion } from 'framer-motion';

interface CurveChartProps {
  data: { month: number; rate: number }[];
  productType: string;
}

export const CurveChart = ({ data, productType }: CurveChartProps) => {
  const chartData = data.map(d => ({
    month: d.month,
    rate: d.rate.toFixed(3)
  }));

  const chartConfig = {
    rate: {
      label: 'Recovery Rate',
      color: 'hsl(var(--chart-1))',
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <Card>
        <CardHeader>
          <CardTitle>Recovery Curve: {productType}</CardTitle>
          <CardDescription>
            Monthly recovery rate as percentage of nominal value
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ChartContainer config={chartConfig} className="h-[400px]">
            <LineChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
              <XAxis 
                dataKey="month" 
                label={{ value: 'Month', position: 'insideBottom', offset: -5 }}
                className="text-xs"
              />
              <YAxis 
                label={{ value: 'Rate (%)', angle: -90, position: 'insideLeft' }}
                tickFormatter={(value) => `${value}%`}
                className="text-xs"
              />
              <ChartTooltip 
                content={
                  <ChartTooltipContent 
                    formatter={(value) => [`${value}%`, 'Recovery Rate']}
                  />
                }
              />
              <Line
                type="monotone"
                dataKey="rate"
                stroke="hsl(var(--chart-1))"
                strokeWidth={2}
                dot={{ fill: 'hsl(var(--chart-1))', r: 3 }}
                animationDuration={500}
              />
            </LineChart>
          </ChartContainer>
        </CardContent>
      </Card>
    </motion.div>
  );
};
